import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/polski';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-270" data-mp="pujdnqvwgpbh">
      <div className="mx-auto max-w-6xl" data-id="element-271" data-mp="b5wmmrwwu94f">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-272" data-mp="b4vccpnpxqnr">
          Co zawiera <em className="text-red-700" data-id="element-273" data-mp="2605dbcuocje">POLSKI GOTOWY™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-274" data-mp="23nfmc0uoxvs">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-275" data-mp="75cp3n8fd3hr">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-276" data-mp="3tbrt6435nd31">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Tomy" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-277" data-mp="3ct4nkoakd3y2">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-278" data-mp="3ltkopr3u3yzr" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-279" data-mp="2y2x1zzp9f4t5">{item.number}</span>
                <span className="mt-1 font-serif text-2xl leading-none" data-id="element-280" data-mp="2advx2mfmybsm">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-281" data-mp="26dc4lw60bwct">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-282" data-mp="eapx7oejthuf">
          <AnimatePresence mode="wait" initial={false} data-id="element-283" data-mp="o23z22tz2tqq">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-284" data-mp="o1kleybcurii">
              <div className="lg:col-span-5" data-id="element-285" data-mp="5bw1e091kvhx">
                <p className="text-sm font-semibold text-red-700" data-id="element-286" data-mp="59jct48s3mvw">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-287" data-mp="1gq9lqv4l6st7">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-288" data-mp="317sb9ig1ov79">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-289" data-mp="2was2v0vq3gcz">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-290" data-mp="2rhpjtmoknpb1">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-291" data-mp="2rgnympdudmfl">Zawiera</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-292" data-mp="2mhtffmbypvuy">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-293" data-mp="2hiq97yk8xjle">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-294" data-mp="2dllt43cwpz3b" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-295" data-mp="23n6363pm8vve">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-296" data-mp="1tycjy4jyru7">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-297" data-mp="2vjtz00oecdck">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-298" data-mp="2zmqaz8jflb7j">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-299" data-mp="2loa2bc20damr">
              Co wyróżnia POLSKI GOTOWY™?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-300" data-mp="2qoej736tw7di">
              Materiały na cały rok szkolny – uporządkowane i gotowe do użycia.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-301" data-mp="2gq8n527pdvgk">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-302" data-mp="27wls5ebbkw8f">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-303" data-mp="1syte6qlf8fwc" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-304" data-mp="1xxwlkhoviy7h">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-305" data-mp="1ec4jr3610swt">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}